export function normalizeStringList(value, fallback = []) {
  const source = Array.isArray(value) ? value : fallback;
  return source
    .filter((item) => typeof item === 'string')
    .map((item) => item.trim())
    .filter(Boolean);
}

export function getPatternYarnWeights(pattern = {}) {
  return normalizeStringList(
    pattern.yarn_weights,
    pattern.yarn_weight ? [pattern.yarn_weight] : [],
  );
}

export function getPatternNeedles(pattern = {}) {
  return normalizeStringList(
    pattern.needles,
    pattern.materials?.needles ? [pattern.materials.needles] : [],
  );
}

export function resolveUploadedMainImage(images, uploadedImageUrls, mainImage) {
  const mainImageIndex = images.findIndex(image => (
    image === mainImage
    || image?.preview === mainImage
    || (mainImage?.preview && image?.preview === mainImage.preview)
  ));

  return mainImageIndex === -1 ? mainImage : uploadedImageUrls[mainImageIndex];
}
